// Calculates nutrient totals for a recipe based on per-100g values + quantity_g
export const computeIngredientTotals = (ingredient) => {
  const factor = (ingredient.quantity_g || 0) / 100;
  const p = ingredient.nutrients_per_100g || {};
  return {
    calories: +(((p.calories || 0) * factor)).toFixed(1),
    protein: +(((p.protein || 0) * factor)).toFixed(1),
    carbs: +(((p.carbs || 0) * factor)).toFixed(1),
    sugars: +(((p.sugars || 0) * factor)).toFixed(1),
    fat: +(((p.fat || 0) * factor)).toFixed(1),
    fiber: +(((p.fiber || 0) * factor)).toFixed(1),
  };
};

export const computeRecipeTotals = (ingredients = []) => {
  const total = { calories: 0, protein: 0, carbs: 0, sugars: 0, fat: 0, fiber: 0, weight_g: 0 };
  for (const ing of ingredients) {
    const t = computeIngredientTotals(ing);
    total.calories += t.calories;
    total.protein += t.protein;
    total.carbs += t.carbs;
    total.sugars += t.sugars;
    total.fat += t.fat;
    total.fiber += t.fiber;
    total.weight_g += ing.quantity_g || 0;
  }
  return {
    calories: +total.calories.toFixed(1),
    protein: +total.protein.toFixed(1),
    carbs: +total.carbs.toFixed(1),
    sugars: +total.sugars.toFixed(1),
    fat: +total.fat.toFixed(1),
    fiber: +total.fiber.toFixed(1),
    weight_g: +total.weight_g.toFixed(1),
  };
};

// Values per 100g of finished product (EU INCO labeling format).
export const computePer100g = (totals) => {
  const w = totals?.weight_g || 0;
  if (w <= 0) {
    return { calories: 0, protein: 0, carbs: 0, sugars: 0, fat: 0, fiber: 0 };
  }
  const f = 100 / w;
  return {
    calories: +(totals.calories * f).toFixed(1),
    protein: +(totals.protein * f).toFixed(1),
    carbs: +(totals.carbs * f).toFixed(1),
    sugars: +(totals.sugars * f).toFixed(1),
    fat: +(totals.fat * f).toFixed(1),
    fiber: +(totals.fiber * f).toFixed(1),
  };
};

export const titleCase = (s = "") =>
  s.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
